

// 定义公告得固定数据

export const navData = [
    {
        name: 'mine.capital.deposit',
        url: '/mine/deposit',
        icon: require('./img/my_nai_deposit.png'),
        // icon02:require('./img/ac-deposit-p.png'),
        index:'0'
    },
    {
        name: 'mine.capital.latestDeposit',
        url: '/mine/latestDeposit',
        icon: require('./img/my_nai_lastest.png'),
        // icon02:require('./img/ac-deposit-p.png'),
        index:'19'
    },
    {
        name: 'mine.capital.withdrawal',
        url: '/mine/withdrawal',
        icon:require('./img/my_nai_withdraw_h.png'),
        // icon02:require('./img/ac-withdraw-p.png'),
        index:'1'
    },
    // {
    //     name: 'mine.capital.account',
    //     url: '/mine/account',
    //     icon:require('./img/ac-state-n.png'),
    //     icon02:require('./img/ac-state-p.png'),
    //     index:'2'
    // },
    {
        name: 'header.Betting',
        url: '/mine/betList',
        icon:require('./img/my_nai_betting.png'),
        // icon02:require('./img/ac-betting-p.png'),
        index:'3'
    },
    {
        name: 'header.transaction',
        url: '/mine/billDetail',
        icon:require('./img/my_nai_transaction.png'),
        // icon02:require('./img/ac-transaction-p-2.png'),
        index:'4'
    },
    {
        name: 'mine.capital.lockAmount',
        url: '/mine/lockAmount',
        icon:require('./img/my_nai_locked.png'),
        // icon02:require('./img/ac-transaction-p.png'),
        index:'5'
    },
    {
        name: 'mine.email.title',
        url: '/mine/inEmail',
        icon:require('./img/my_nai_message_h.png'),
        // icon02:require('./img/ac-fri-p.png'),
        index:'9'
    },
    {
        name: 'dialog.task',
        url: '/mine/task',
        icon:require('./img/my_nai_task.png'),
        index:'12'
    },
    {
        name: 'mine.friend',
        url: '/mine/invitation',
        icon:require('./img/my_nai_friend.png'),
        // icon02:require('./img/ac-fri-p-2.png'),
        index:'8'
    },
    {
        name: 'mine.AccountManagement',
        url: '/mine/safety',
        icon:require('./img/my_nai_account.png'),
        // icon02:require('./img/ac-manage-p.png'),
        index:'6'
    },
    // {
    //     name:'slot.mineCollect',
    //     url: '/mine/myCollect',
    //     index:'7',
    // },
   
    
]



// WEBPACK FOOTER //
// ./src/pages/build902/views/mine/index.js